import React from 'react';
import { Link } from 'react-router-dom';
import './Policy.css';

const TermsConditions = () => (
  <div className="policy-page terms-conditions-page">
    <div className="page-header">
      <div className="page-header-content">
        <div className="container">
          <h1>TERMS &amp; CONDITIONS</h1>
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Terms &amp; Conditions</span>
          </div>
          <p className="policy-banner-note">Last updated on 12 Sep, 2026</p>
        </div>
      </div>
    </div>
    <section className="policy-content">
      <div className="container">
        <div className="policy-box">
          <h2>DigiRasa – Terms &amp; Conditions</h2>
          <p>
            <strong>Effective Date:</strong> 12/09/2026
            <br />
            <strong>Last Updated:</strong> 12/09/2026
          </p>
          <p>
            These Terms &amp; Conditions (“Terms”, “Terms &amp; Conditions” or “Agreement”) govern
            your access to and use of the DigiRasa website, mobile application, meal plans,
            subscriptions, food ordering services, delivery services and related services
            (“Services”) operated by Bulusu Digital Innovations Pvt. Ltd., operating under the
            brand name DigiRasa (“DigiRasa”, “Company”, “we”, “us” or “our”).
          </p>
          <p>
            <strong>Registered Office:</strong>
            <br />
            9-22/B/20, Boduppal, Ghatkesar, Hyderabad – 500092, Telangana, India.
          </p>
          <p>
            By accessing, browsing, registering on, placing an order through, subscribing to, or
            otherwise using DigiRasa Services, you acknowledge that you have read, understood and
            agreed to these Terms &amp; Conditions and the policies referred to in them.
          </p>

          <h3>1. Acceptance of Terms</h3>
          <p>
            1.1 These Terms apply to all users, customers, subscribers and visitors using DigiRasa
            Services.
          </p>
          <p>
            1.2 By using the DigiRasa website, application or Services, you agree to be legally
            bound by these Terms and all applicable policies published by DigiRasa.
          </p>
          <p>
            1.3 If you do not agree with these Terms, you must not access or use the DigiRasa
            Services.
          </p>
          <p>
            1.4 DigiRasa may update, modify or replace these Terms from time to time. The latest
            version will be made available on the DigiRasa website and/or application.
          </p>
          <p>
            1.5 Your continued use of DigiRasa Services after an updated version becomes available
            constitutes acceptance of the revised Terms, subject to applicable law.
          </p>

          <h3>2. Eligibility and Terms of Use</h3>
          <p>
            2.1 You must provide accurate, complete and current information when registering or
            placing an order.
          </p>
          <p>
            2.2 You must be legally capable of entering into a contract under applicable law.
          </p>
          <p>
            2.3 Where a minor uses DigiRasa Services, the account and use of the Services must be
            authorised and supervised by the minor’s parent or legal guardian.
          </p>
          <p>
            2.4 A corporate, institutional or other organisational customer must ensure that the
            person placing an order or subscription is duly authorised to act on behalf of that
            organisation.
          </p>
          <p>
            2.5 Customers are responsible for maintaining the confidentiality of their account
            information and for activities carried out through their account.
          </p>

          <h3>3. Prohibited Use</h3>
          <p>You shall not use DigiRasa Services:</p>
          <p>3.1 For any unlawful, fraudulent or unauthorised purpose.</p>
          <p>
            3.2 To upload or transmit threatening, abusive, obscene, vulgar, pornographic,
            defamatory, hateful, discriminatory or otherwise unlawful material.
          </p>
          <p>
            3.3 To impersonate another person, entity, employee, representative or customer.
          </p>
          <p>
            3.4 To interfere with or attempt to compromise the security or operation of the
            DigiRasa website, application, systems or networks.
          </p>
          <p>3.5 To introduce viruses, malware, bots, worms or other harmful code.</p>
          <p>
            3.6 To reverse engineer, decompile, copy or attempt to obtain the source code of the
            application, website or related technology, except where permitted by applicable law.
          </p>
          <p>
            3.7 To access accounts, information, systems or data without proper authorisation.
          </p>
          <p>
            3.8 To scrape, collect or reproduce DigiRasa content or information through automated
            means without written permission.
          </p>
          <p>3.9 To use DigiRasa Services for unsolicited bulk communications or spam.</p>
          <p>
            3.10 To infringe intellectual-property, privacy or other legal rights of DigiRasa or
            third parties.
          </p>
          <p>
            3.11 To falsely represent information relating to orders, payments, delivery or
            customer identity.
          </p>
          <p>
            3.12 To misuse promotional offers, referral programs, coupons or subscription
            benefits.
          </p>
          <p>3.13 To place fraudulent or deliberately misleading orders.</p>
          <p>
            3.14 To otherwise interfere with the proper functioning or legitimate use of DigiRasa
            Services.
          </p>
          <p>
            DigiRasa may restrict, suspend or terminate accounts or access where reasonably
            necessary, subject to applicable law.
          </p>

          <h3>4. Orders and Order Confirmation</h3>
          <p>
            4.1 Customers may place food orders and subscriptions through DigiRasa’s authorised
            website, mobile application or other officially approved ordering channels.
          </p>
          <p>4.2 An order or subscription shall be considered successfully placed only when:</p>
          <p>a. the required payment has been successfully processed and confirmed; and</p>
          <p>
            b. DigiRasa has successfully received the payment confirmation and
            generated/communicated the relevant order or subscription confirmation.
          </p>
          <p>
            4.3 Merely selecting a meal, adding an item to a cart, submitting an order request,
            receiving a payment-page response, or seeing a pending payment status does not by
            itself constitute a successfully placed order.
          </p>
          <p>
            4.4 DigiRasa may decline or cancel an order before confirmation where permitted by
            applicable law due to non-availability, operational constraints, technical errors,
            suspected fraud, regulatory requirements or other legitimate reasons.
          </p>
          <p>
            4.5 Customers should review meal details, quantity, schedule, delivery address, price,
            taxes and other applicable charges before confirming payment.
          </p>

          <h3>5. Subscription Services</h3>
          <p>
            5.1 DigiRasa provides meal subscription plans according to the plans, meal frequency,
            duration, schedule and other options displayed on the website/application.
          </p>
          <p>5.2 Subscription activation is subject to:</p>
          <p>a. selection of the applicable plan;</p>
          <p>b. submission of the required customer information;</p>
          <p>c. successful payment confirmation; and</p>
          <p>d. DigiRasa’s successful order/subscription confirmation.</p>
          <p>
            5.3 The subscription start date and duration shall be based on the plan selected and
            the information displayed during subscription.
          </p>
          <p>
            5.4 Unless otherwise stated for a particular plan, the subscription start date may be
            from the next eligible delivery date after successful confirmation.
          </p>
          <p>
            5.5 Customers are responsible for providing accurate contact, delivery and scheduling
            information.
          </p>
          <p>
            5.6 DigiRasa may contact customers through phone, SMS, email, WhatsApp or application
            notifications regarding their order, subscription, delivery, customer support and,
            where legally permitted, promotional communications.
          </p>

          <h3>6. Pause / Skip / Resume of Subscriptions</h3>
          <p>
            6.1 Eligible subscription customers may use DigiRasa’s available pause, skip or resume
            functionality subject to the rules applicable to their plan.
          </p>
          <p>
            6.2 A customer may request to skip or pause an upcoming meal only by using the
            available DigiRasa application/website function or by contacting DigiRasa customer
            support within the prescribed notice period.
          </p>
          <p>
            6.3 <strong>Minimum Notice:</strong> A skip or pause request must be made at least 24
            hours before the scheduled delivery time of the affected meal, unless a different
            cut-off time is specifically displayed for the applicable plan or service area.
          </p>
          <p>
            6.4 Requests received after the applicable cut-off time may be treated as too late for
            operational purposes, and DigiRasa may be unable to skip that meal.
          </p>
          <p>
            6.5 <strong>Maximum Pause:</strong> Unless otherwise specified for a particular
            subscription plan, a subscription may be paused for a maximum of 2 consecutive weeks
            pause request.
          </p>
          <p>
            6.6 The maximum pause duration may vary according to the subscription plan and
            operational availability. The applicable limit shown in the application or
            communicated by DigiRasa shall prevail.
          </p>
          <p>
            6.7 Skipped or paused meals will not automatically result in a cash refund. Eligible
            skipped meals will be carried forward and the corresponding subscription period will
            be extended by the number of eligible meals/days skipped, subject to the applicable
            plan rules.
          </p>
          <p>
            6.8 The extension will normally be calculated based on the number of eligible
            scheduled meals successfully skipped.
          </p>
          <p>
            6.9 No extension will be provided for a meal that was not skipped within the
            applicable notice period or where the request was not successfully recorded by
            DigiRasa.
          </p>
          <p>
            6.10 Customers may resume a paused subscription through the DigiRasa
            application/website or by contacting customer support.
          </p>
          <p>
            6.11 Upon resumption, the subscription will continue from the next eligible delivery
            date available under the applicable plan.
          </p>
          <p>
            6.12 Customers are responsible for checking the updated schedule/end date after
            submitting a pause or skip request.
          </p>
          <p>
            6.13 Unless specifically stated otherwise, pause, skip and resume provisions do not
            convert subscription benefits into cash and do not constitute cancellation of the
            subscription.
          </p>

          <h3>7. Website Meal Plan Subscriptions</h3>
          <p>
            7.1 Website meal plan subscriptions are subject to these Terms and the applicable{' '}
            <Link to="/refund_returns">Refund &amp; Cancellation Policy</Link>.
          </p>
          <p>
            7.2 Plan availability may be subject to kitchen capacity, service-area availability,
            operating schedules and other operational requirements.
          </p>
          <p>
            7.3 Subscription pricing may be calculated based on the selected meals, frequency,
            duration, packaging, taxes and applicable delivery charges.
          </p>
          <p>
            7.4 The final payable amount shall be displayed before payment confirmation.
          </p>
          <p>
            7.5 Breakfast, lunch, snacks and dinner services may be offered according to the
            selected plan and schedule.
          </p>
          <p>
            7.6 DigiRasa may provide different meal schedules or combinations for different plans.
          </p>
          <p>
            7.7 Customers should review their selected plan carefully before completing payment.
          </p>

          <h3>8. Food Information and Customer Responsibility</h3>
          <p>
            8.1 DigiRasa endeavours to provide accurate information regarding meals, ingredients,
            nutritional information and other food-related information wherever applicable.
          </p>
          <p>
            8.2 Customers should review available meal and ingredient information before ordering.
          </p>
          <p>
            8.3 Food images displayed on the website or application are for representation and may
            not always exactly match the delivered meal.
          </p>
          <p>
            8.4 Meal availability and ingredients may change due to seasonal availability,
            sourcing, operational requirements or other legitimate reasons.
          </p>
          <p>
            8.5 Customers should contact DigiRasa before ordering if they require clarification
            regarding a particular ingredient, preparation method or meal.
          </p>

          <h3>9. Allergies and Dietary Restrictions</h3>
          <p>
            9.1 Customers must inform DigiRasa about any known food allergy, intolerance, dietary
            restriction or other specific food-related concern before placing an order.
          </p>
          <p>
            9.2 Customers should carefully review the ingredients and food information provided by
            DigiRasa before ordering.
          </p>
          <p>
            9.3 Customers should contact DigiRasa customer support where they require
            clarification regarding specific ingredients or dietary requirements.
          </p>
          <p>
            9.4 DigiRasa cannot guarantee an allergen-free environment unless the particular
            product or service is expressly stated by DigiRasa to be prepared and handled as
            allergen-free.
          </p>
          <p>
            9.5 Although DigiRasa may consider reasonable customisation requests where
            operationally possible, customisation does not automatically guarantee the complete
            absence of allergens or cross-contact.
          </p>
          <p>
            9.6 Customers with severe food allergies or medically significant dietary requirements
            should exercise appropriate caution and seek clarification from DigiRasa before
            ordering.
          </p>
          <p>
            9.7 DigiRasa shall comply with applicable food-safety and information requirements,
            but customers remain responsible for informing DigiRasa of relevant allergies and
            restrictions before ordering.
          </p>

          <h3>10. Pricing, GST and Taxes</h3>
          <p>
            10.1 DigiRasa shall maintain a consistent pricing presentation across its website and
            application to the extent reasonably practicable.
          </p>
          <p>
            10.2 Unless expressly stated otherwise, prices displayed for DigiRasa products and
            subscriptions are exclusive of applicable GST. GST will be charged at the applicable
            rate and displayed before payment confirmation.
          </p>
          <p>
            10.3 Where DigiRasa decides to display prices inclusive of GST for a particular
            product or plan, the applicable display shall clearly indicate that the price is
            inclusive of GST.
          </p>
          <p>
            10.4 Delivery charges, where applicable, shall be clearly displayed before the
            customer completes payment.
          </p>
          <p>
            10.5 Packaging, special handling, service charges or other additional charges, where
            applicable, shall be disclosed before order confirmation.
          </p>
          <p>10.6 DigiRasa may correct pricing, tax, calculation or display errors.</p>
          <p>
            10.7 Where a clear pricing error occurs, DigiRasa may, subject to applicable law,
            cancel the affected order or communicate the correct payable price before fulfilment.
          </p>
          <p>
            10.8 Subscription prices and promotional prices are valid only for the period and
            conditions specified by DigiRasa.
          </p>

          <h3>11. Payment</h3>
          <p>
            11.1 Payments may be processed through authorised third-party payment gateways and
            supported payment methods.
          </p>
          <p>
            11.2 Customers confirm that the payment information provided by them is accurate and
            that they are authorised to use the selected payment method.
          </p>
          <p>
            11.3 Payment processing is subject to the terms, conditions and security procedures of
            the relevant payment service provider.
          </p>
          <p>
            11.4 Successful payment confirmation is necessary for an order or subscription to be
            treated as successfully placed.
          </p>
          <p>
            11.5 A payment being initiated, pending, authorised but not confirmed, or debited
            without corresponding DigiRasa confirmation does not by itself establish that the
            order has been successfully placed.
          </p>
          <p>
            11.6 DigiRasa does not control third-party payment systems and shall not be
            responsible for failures caused solely by the customer’s bank, payment provider, card
            network or other external payment intermediary, subject to applicable law.
          </p>

          <h3>12. Payment Failures / Duplicate Payments</h3>
          <p>
            12.1 If a payment fails but the customer&apos;s bank account, card or payment
            instrument has nevertheless been debited, DigiRasa will verify the transaction status
            with the relevant payment gateway/payment provider.
          </p>
          <p>
            12.2 If DigiRasa does not receive successful payment confirmation and the transaction
            is subsequently identified as failed or reversed, the amount shall be reconciled and
            returned/reversed through the applicable payment channel, subject to banking and
            payment-provider processes.
          </p>
          <p>
            12.3 Where payment is successful, but the order is not immediately confirmed,
            customers should first check their order status in the DigiRasa application/website
            and contact customer support if confirmation is not received.
          </p>
          <p>
            12.4 DigiRasa will verify the transaction and, where payment has been successfully
            received, either confirm the applicable order/subscription or initiate the appropriate
            reconciliation process.
          </p>
          <p>
            12.5 Where a customer accidentally makes multiple payments for the same order or
            subscription, DigiRasa will verify the duplicate transaction and, where an excess
            payment is confirmed, initiate the applicable reversal/refund process.
          </p>
          <p>
            12.6 DigiRasa will ordinarily initiate an eligible payment reconciliation or refund
            within 5–7 business days after verification/confirmation of the relevant transaction,
            unless a different timeframe is required by the applicable payment provider, bank or
            law.
          </p>
          <p>
            12.7 The actual credit of a reversed/refunded amount to the customer’s bank account,
            card or payment instrument may take additional time depending on the customer’s
            bank/payment provider.
          </p>
          <p>
            12.8 Customers should retain transaction IDs, payment references and relevant proof of
            payment when contacting DigiRasa regarding a payment issue.
          </p>

          <h3>13. Listed Price and Payment Confirmation</h3>
          <p>
            13.1 The final payable price shown at checkout shall include the applicable
            product/subscription price, GST and disclosed additional charges, as applicable.
          </p>
          <p>
            13.2 Customers are responsible for reviewing the final payable amount before
            completing payment.
          </p>
          <p>
            13.3 A successful payment does not by itself constitute final order confirmation
            unless DigiRasa receives the payment confirmation and generates/communicates an order
            or subscription confirmation.
          </p>
          <p>
            13.4 DigiRasa shall not be required to prepare or deliver an order for which
            successful payment confirmation has not been received, subject to applicable law.
          </p>

          <h3>14. Delivery</h3>
          <p>
            14.1 DigiRasa may provide delivery services for breakfast, lunch, snacks and dinner
            according to the applicable plan and service schedule.
          </p>
          <p>
            14.2 Delivery times may vary depending on distance, traffic, weather, operational
            conditions, demand and other circumstances beyond DigiRasa’s reasonable control.
          </p>
          <p>
            14.3 Estimated delivery times are indicative and may not constitute guaranteed
            delivery times unless expressly stated otherwise.
          </p>
          <p>
            14.4 Customers should ensure that the delivery address is accurate, accessible and
            available during the applicable delivery window.
          </p>
          <p>
            14.5 DigiRasa may contact the customer where delivery requires clarification or
            assistance.
          </p>
          <p>
            14.6 Where a customer has requested or permitted delivery to a reception desk,
            security gate, lobby or other designated location, responsibility for the meal after
            delivery to that authorised location may pass to the customer, subject to applicable
            law.
          </p>
          <p>
            14.7 Where a delivery cannot be completed due to circumstances attributable to the
            customer, including incorrect address, unavailable recipient or inaccessible premises,
            DigiRasa may take reasonable steps to contact the customer and redeliver where
            operationally feasible.
          </p>
          <p>
            14.8 Certain public holidays, operational closures or circumstances affecting delivery
            availability may result in modified or suspended delivery schedules. DigiRasa may
            provide advance communication where reasonably practicable.
          </p>

          <h3>15. Delivery Address and Customer Responsibility</h3>
          <p>
            15.1 Customers must provide a complete and accurate delivery address, contact number
            and other relevant delivery instructions.
          </p>
          <p>
            15.2 Customers are responsible for promptly updating any changes to their delivery
            information.
          </p>
          <p>
            15.3 DigiRasa shall not be responsible for delays or failed delivery caused by
            inaccurate or incomplete information supplied by the customer, subject to applicable
            law.
          </p>
          <p>
            15.4 Customers should ensure that meals can be safely received and stored after
            delivery.
          </p>

          <h3>16. Food Quality and Service Concerns</h3>
          <p>
            16.1 DigiRasa aims to maintain appropriate standards of food quality, preparation,
            packaging and delivery.
          </p>
          <p>
            16.2 Customers should promptly report concerns relating to missing items, incorrect
            items, packaging issues, quality concerns or other service issues through DigiRasa
            customer support.
          </p>
          <p>
            16.3 DigiRasa may request relevant information, photographs, order details or other
            reasonable evidence to investigate a complaint.
          </p>
          <p>
            16.4 Complaints shall be reviewed and addressed in accordance with DigiRasa’s
            applicable policies and applicable law.
          </p>
          <p>
            16.5 Any refund, replacement, credit, subscription adjustment or other remedy shall be
            governed by the applicable{' '}
            <Link to="/refund_returns">Refund &amp; Cancellation Policy</Link> and/or other
            applicable policy.
          </p>

          <h3>17. Refunds and Cancellations</h3>
          <p>
            17.1 Refunds and cancellations are governed by DigiRasa’s separate{' '}
            <Link to="/refund_returns">Refund &amp; Cancellation Policy</Link>.
          </p>
          <p>
            17.2 The Refund &amp; Cancellation Policy forms part of the overall DigiRasa customer
            agreement and should be read together with these Terms.
          </p>
          <p>
            17.3 Where these Terms refer to cancellation, refund, reversal, replacement or other
            payment adjustment, the applicable Refund &amp; Cancellation Policy and mandatory
            applicable law shall govern.
          </p>
          <p>
            17.4 Nothing in these Terms shall be interpreted as excluding rights or remedies that
            cannot lawfully be excluded.
          </p>

          <h3>18. Health, Food Safety and Medical Disclaimer</h3>
          <p>
            18.1 DigiRasa provides food and meal services and does not provide medical, clinical
            or dietary treatment.
          </p>
          <p>
            18.2 Information regarding meals, nutrition or lifestyle should not be treated as
            medical advice unless expressly provided by a qualified professional independently
            engaged for that purpose.
          </p>
          <p>
            18.3 Customers with medical conditions, allergies, dietary restrictions or other
            special requirements should consult an appropriate qualified professional and
            independently assess whether a particular meal is suitable for them.
          </p>
          <p>
            18.4 DigiRasa shall follow applicable food-safety requirements applicable to its
            operations.
          </p>
          <p>
            18.5 Customers should follow appropriate instructions for receiving, storing and
            consuming delivered food.
          </p>

          <h3>19. Platform Disclaimer</h3>
          <p>
            19.1 DigiRasa endeavours to keep website and application information accurate and
            available but does not guarantee that the platform will always be uninterrupted,
            error-free or continuously available.
          </p>
          <p>
            19.2 Services may be affected by maintenance, upgrades, technical faults,
            telecommunications failures, internet disruptions, emergencies, weather conditions or
            other events beyond DigiRasa’s reasonable control.
          </p>
          <p>
            19.3 DigiRasa may temporarily suspend, restrict or modify parts of the Services when
            reasonably required for maintenance, safety, security, compliance or operational
            reasons.
          </p>

          <h3>20. Intellectual Property</h3>
          <p>
            20.1 All content, branding, logos, designs, text, images, graphics, software, features
            and functionality provided through DigiRasa Services are owned by or licensed to
            DigiRasa or its relevant licensors.
          </p>
          <p>
            20.2 Customers may use DigiRasa Services only for lawful personal or authorised
            business use.
          </p>
          <p>
            20.3 No customer may reproduce, modify, distribute, publish, sell, licence, reverse
            engineer or create derivative works from DigiRasa materials without prior written
            permission, except where permitted by applicable law.
          </p>
          <p>
            20.4 DigiRasa branding, logos and trademarks may not be used without prior written
            authorisation.
          </p>

          <h3>21. Privacy and Customer Data</h3>
          <p>
            21.1 Customer information shall be handled in accordance with DigiRasa’s applicable{' '}
            <Link to="/privacy-policy">Privacy Policy</Link> and applicable law.
          </p>
          <p>
            21.2 Customers should review the Privacy Policy to understand how personal information
            may be collected, used, stored and processed.
          </p>
          <p>
            21.3 Customers are responsible for ensuring that information supplied through their
            account is accurate and belongs to them or is otherwise lawfully provided.
          </p>
          <p>
            21.4 DigiRasa may use necessary customer information to process orders, provide
            delivery, communicate regarding Services, provide customer support, prevent fraud and
            fulfil legal or operational obligations.
          </p>

          <h3>22. Communications and Promotional Contact</h3>
          <p>
            22.1 DigiRasa may contact customers regarding order confirmation, payment status,
            delivery, subscription management, support requests and other service-related matters.
          </p>
          <p>
            22.2 Promotional communications may be sent through permitted communication channels
            subject to applicable law and customer preferences/consents where required.
          </p>
          <p>
            22.3 Customers may use available unsubscribe or preference-management options for
            promotional communications where provided.
          </p>
          <p>
            22.4 Service-related communications necessary to fulfil an order, subscription or
            support request may continue where legally permitted.
          </p>

          <h3>23. Third-Party Services and Links</h3>
          <p>
            23.1 DigiRasa may use third-party service providers for payment processing,
            communications, delivery, analytics, technology and other operational functions.
          </p>
          <p>
            23.2 Third-party services may be subject to the third party’s own terms and policies.
          </p>
          <p>
            23.3 DigiRasa may provide links to third-party websites or services for convenience.
            DigiRasa does not control all third-party content or services and is not responsible
            for their independent policies or practices, subject to applicable law.
          </p>

          <h3>24. Account Security</h3>
          <p>
            24.1 Customers are responsible for keeping their login credentials, mobile number,
            OTPs and account-access information secure.
          </p>
          <p>
            24.2 Customers must notify DigiRasa promptly if they suspect unauthorised access or
            misuse of their account.
          </p>
          <p>
            24.3 DigiRasa may take reasonable steps to restrict or secure an account where
            suspicious or unauthorised activity is detected.
          </p>

          <h3>25. Liability</h3>
          <p>
            25.1 To the maximum extent permitted by applicable law, DigiRasa shall not be liable
            for losses arising solely from circumstances beyond its reasonable control, including
            telecommunications failures, payment-gateway outages, extreme weather, traffic
            disruptions, government restrictions or other external events.
          </p>
          <p>
            25.2 Nothing in these Terms excludes or limits liability to the extent such exclusion
            or limitation is prohibited by applicable law.
          </p>
          <p>
            25.3 DigiRasa’s liability, where legally applicable, shall be determined in accordance
            with applicable law and the circumstances of the relevant claim.
          </p>

          <h3>26. Indemnification</h3>
          <p>
            26.1 To the extent permitted by applicable law, the customer agrees to indemnify
            DigiRasa against losses, claims, liabilities or reasonable costs arising from:
          </p>
          <p>a. the customer’s unlawful use of DigiRasa Services;</p>
          <p>b. violation of these Terms;</p>
          <p>c. misuse of the customer’s account;</p>
          <p>d. fraudulent or unauthorised activities attributable to the customer; or</p>
          <p>e. infringement of third-party rights caused by the customer.</p>
          <p>
            26.2 This provision shall not apply to the extent that a loss results from DigiRasa’s
            own unlawful conduct, negligence or other liability that cannot legally be transferred
            to the customer.
          </p>

          <h3>27. Governing Law and Jurisdiction</h3>
          <p>27.1 These Terms shall be governed by the laws of India.</p>
          <p>
            27.2 Subject to applicable consumer-protection laws and jurisdictional requirements,
            disputes relating to DigiRasa Services shall be subject to the jurisdiction of the
            competent courts in Hyderabad, Telangana.
          </p>

          <h3>28. Grievance Redressal and Customer Support</h3>
          <p>
            28.1 DigiRasa maintains a customer-support for addressing customer concerns.
          </p>
          <p>
            Customer Support Email:{' '}
            <a href="mailto:customercare@digirasa.com">customercare@digirasa.com</a>
            <br />
            Customer Support Phone:{' '}
            <a href="tel:+918143231857">+91 8143231857</a>
          </p>
          <p>
            28.2 Customers may contact DigiRasa using the above details for order, subscription,
            delivery, payment or other service-related concerns.
          </p>
          <p>
            28.3 DigiRasa shall handle grievances in accordance with applicable law and its
            internal grievance procedures.
          </p>
          <p>
            28.4 The applicable acknowledgement and resolution requirements shall be followed as
            required by law. Official consumer-protection guidance states that e-commerce entities
            are required to maintain a grievance mechanism and publish relevant grievance-officer
            details.
          </p>

          <h3>29. Food Safety and Regulatory Information</h3>
          <p>
            29.1 DigiRasa shall comply with food-safety requirements applicable to its operations.
          </p>
          <p>
            29.2 Where applicable, required food information, ingredient information, nutritional
            information, FSSAI information and other required disclosures shall be provided
            through the appropriate product packaging, website, application or other legally
            prescribed method.
          </p>
          <p>
            29.3 DigiRasa’s applicable FSSAI licence/registration details shall be displayed where
            legally required.
          </p>
          <p>
            <strong>FSSAI Licence/Registration No.:</strong> 23624032002616
          </p>
          <p>
            29.4 Food information displayed online shall be maintained consistently with
            applicable regulatory requirements. FSSAI guidance specifically addresses food-business
            information provided through e-commerce channels.
          </p>

          <h3>30. Miscellaneous</h3>
          <p>
            30.1 <strong>Severability:</strong> If any provision of these Terms is found invalid
            or unenforceable, the remaining provisions shall continue to the extent permitted by
            law.
          </p>
          <p>
            30.2 <strong>No Waiver:</strong> Failure by DigiRasa to enforce a provision of these
            Terms shall not constitute a waiver of that provision.
          </p>
          <p>
            30.3 <strong>Assignment:</strong> Customers may not assign or transfer their rights or
            obligations under these Terms without DigiRasa’s prior written consent where such
            consent is required.
          </p>
          <p>
            30.4 <strong>Entire Agreement:</strong> These Terms, together with the{' '}
            <Link to="/privacy-policy">Privacy Policy</Link>,{' '}
            <Link to="/refund_returns">Refund &amp; Cancellation Policy</Link> and other
            applicable policies expressly referred to herein, constitute the agreement governing
            use of the DigiRasa Services.
          </p>
          <p>
            30.5 <strong>Headings:</strong> Section headings are provided for convenience and do
            not affect interpretation.
          </p>

          <h3>31. Account After Death</h3>
          <p>
            31.1 Where DigiRasa receives verified information regarding the death of a customer,
            DigiRasa may restrict or suspend access to the customer’s account for security and
            legal reasons.
          </p>
          <p>
            31.2 Any transfer, closure, outstanding balance, subscription benefit or other
            account matter shall be handled in accordance with applicable law and DigiRasa’s
            policies.
          </p>
          <p>
            31.3 DigiRasa may request appropriate documentation before processing requests
            relating to a deceased customer’s account.
          </p>

          <h3>32. Prevailing Language</h3>
          <p>
            32.1 These Terms may be provided in English and/or other languages.
          </p>
          <p>
            32.2 In the event of any conflict between translated versions, the English version
            shall prevail to the extent permitted by applicable law.
          </p>

          <h3>33. T&amp;C Updates</h3>
          <p>
            33.1 DigiRasa may update, revise or modify these Terms &amp; Conditions from time to
            time to reflect changes in Services, operations, technology, applicable law or
            business requirements.
          </p>
          <p>
            33.2 The latest version of these Terms &amp; Conditions will be made available on the
            DigiRasa website and/or mobile application.
          </p>
          <p>
            33.3 DigiRasa may provide additional notice of material changes through the
            application, website, email, SMS, WhatsApp or other appropriate communication methods
            where reasonably practicable.
          </p>
          <p>33.4 Customers should periodically review the latest version of these Terms.</p>
          <p>
            33.5 Continued use of DigiRasa Services after the updated Terms become effective
            constitutes acceptance of the revised Terms, subject to applicable law.
          </p>

          <h3>34. Important Policies and Documents</h3>
          <p>
            These Terms should be read together with the following DigiRasa policies and
            documents, as applicable:
          </p>
          <p>
            <strong>A. Privacy Policy</strong>
            <br />
            Explains the collection and use of customer information.{' '}
            <Link to="/privacy-policy">Read the Privacy Policy</Link>.
          </p>
          <p>
            <strong>B. Refund &amp; Cancellation Policy</strong>
            <br />
            Provides the separate rules governing eligible cancellations, refunds, reversals and
            related adjustments.{' '}
            <Link to="/refund_returns">Read the Refund &amp; Cancellation Policy</Link>.
          </p>
          <p>
            <strong>C. Subscription / Meal Plan Rules</strong>
            <br />
            Provides plan-specific operational conditions, including applicable pause, skip and
            resume limits.
          </p>
          <p>
            <strong>D. Other Applicable Policies</strong>
            <br />
            Any promotional, referral, delivery or service-specific policy communicated by
            DigiRasa.
          </p>
          <p>
            Where a specific policy contains plan-specific terms, those terms will apply to that
            particular service or promotion, subject to applicable law.
          </p>

          <h3>35. Contact Information</h3>
          <p>
            <strong>Bulusu Digital Innovations Pvt. Ltd. – DigiRasa</strong>
          </p>
          <p>
            <strong>Registered Office:</strong>
            <br />
            9-22/B/20, Boduppal, Ghatkesar,
            <br />
            Hyderabad – 500092, Telangana, India.
          </p>
          <p>
            <strong>Kitchen Address:</strong>
            <br />
            Plot No: HIG-137, Huda Complex, Mayuri Nagar,
            <br />
            Hyderabad – 500092, Telangana, India.
          </p>
          <p>
            Website:{' '}
            <a href="https://www.digirasa.com/" target="_blank" rel="noopener noreferrer">
              https://www.digirasa.com/
            </a>
          </p>
          <p>
            <strong>Customer Support:</strong>
            <br />
            Email:{' '}
            <a href="mailto:customercare@digirasa.com">customercare@digirasa.com</a>
            <br />
            Phone: <a href="tel:+918143231857">+91 8143231857</a>
          </p>
          <p>
            <strong>FSSAI Licence/Registration No.:</strong> 23624032002616
          </p>
          <p>
            By using DigiRasa Services, you acknowledge that you have read and agreed to these
            Terms &amp; Conditions and the applicable policies referred to herein.
          </p>

          <div className="policy-help-box">
            <h3>DigiRasa</h3>
            <p>Operated by Bulusu Digital Innovations Pvt. Ltd.</p>
            <p>
              <strong>Registered Office:</strong>
              <br />
              9-22/B/20, Boduppal, Ghatkesar,
              <br />
              Hyderabad – 500092, Telangana, India.
            </p>
            <p>
              <strong>Kitchen Address:</strong>
              <br />
              Plot No: HIG-137, Huda Complex, Mayuri Nagar,
              <br />
              Hyderabad – 500092, Telangana, India.
            </p>
            <p>
              <strong>Customer Support:</strong>{' '}
              <a href="mailto:customercare@digirasa.com">customercare@digirasa.com</a>
              {' | '}
              <a href="tel:+918143231857">+91 8143231857</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default TermsConditions;
